module.exports = __webpack_public_path__ + "static/media/background.836a79c6.jpg";